import { memo, useState } from "react";
import "./tabmenu.css";
import Skeleton from "../skeleton/Skeleton";

export enum TabMenuType {
  ACTIVE,
  INACTIVE,
  PENDING,
  UNASSIGNED,
}

export interface TabmenuItem {
  type: TabMenuType;
  title: string;
  value: number;
}

type TabmenuProps = {
  items: TabmenuItem[];
  isLoading: boolean;
  onTabSelected: (index: number) => void;
  isDisabled: boolean;
};

const Tabmenu: React.FC<TabmenuProps> = ({ items, onTabSelected, isDisabled, isLoading }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  function getValueClassName(type: TabMenuType): string {
    switch (type) {
      case TabMenuType.ACTIVE:
        return "label-medium value active";
      case TabMenuType.INACTIVE:
        return "label-medium value inactive";
      case TabMenuType.PENDING:
        return "label-medium value pending";
      case TabMenuType.UNASSIGNED:
        return "label-medium value unassigned";
    }
  }

  return (
    <div className="tab-menu">
      {items.map((item, index) => {
        return (
          <button
            disabled={isDisabled}
            key={index}
            className={selectedTabIndex === index ? "tab-menu-item selected" : "tab-menu-item"}
            onClick={() => {
              console.log("Onclicked tab index : ", index);
              setSelectedTabIndex(index);
              onTabSelected(index);
            }}
          >
            <div className="overlay"></div>
            <div className="title-small title">{item.title}</div>
            &nbsp; <div className={getValueClassName(item.type)}>{isLoading ? <Skeleton /> : item.value}</div>
            {/* &nbsp; <div className={getValueClassName(item.type)}>{isLoading ? <Skeleton /> : <Skeleton />}</div> */}
            <div className="selection-indicator"></div>
          </button>
        );
      })}
    </div>
  );
};

export default memo(Tabmenu);
